import * as Yup from 'yup';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import Alert from '@material-ui/lab/Alert';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate } from 'react-router-dom';
// material
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Card,
  CardContent
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { values } from 'lodash';
import { useClientContext } from '../../../context/client_context';
import { baseUrl } from '../../../utils/constants';

// ----------------------------------------------------------------------

export default function RegisterForm() {
  const { clientRefId, currentClient, setClientRefId, setCurrentClient } = useClientContext();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const RegisterSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('First name required'),
    surname: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last name required'),
    emailAddress: Yup.string()
      .email('Email must be a valid email address')
      .required('Email is required'),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      firstName: '',
      surname: '',
      idNumber: '',
      cellNumber: '',
      emailAddress: '',
      password: '',
      confirmPassword: '',
      loginType: 0,
      loginIdentifier: '',
      alternateLoginIdentifier: null,
      partnerRefId: 1
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      formik.values.loginIdentifier = formik.values.emailAddress;
      handleFormUpdate(formik.values);
      console.log('Form data on Register', formik.values);
      // navigate('/dashboard', { replace: true });
    }
  });

  const handleFormUpdate = (e) => {
    saveClientData(e);
  };

  const saveClientData = (client) => {
    console.log('Form data in Save Register', client);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('reg info stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/CustomerAuthentication/CustomerRegistration?sendLoginSms=true`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // setClientRefId(result.refId);
          // setCurrentClient(result);
          console.log('from registration', result);
          <Alert variant="filled" severity="success">
            Client Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Registration, Please call for assistance!, {error}
          </Alert>;
        }
      );
  };

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  label="First name"
                  {...getFieldProps('firstName')}
                  error={Boolean(touched.firstName && errors.firstName)}
                  helperText={touched.firstName && errors.firstName}
                />

                <TextField
                  fullWidth
                  label="Last name"
                  {...getFieldProps('surname')}
                  error={Boolean(touched.surname && errors.surname)}
                  helperText={touched.surname && errors.surname}
                />
              </Stack>

              <TextField
                fullWidth
                autoComplete="idNumber"
                type="string"
                label="Id Number"
                {...getFieldProps('idNumber')}
                error={Boolean(touched.idNumber && errors.idNumber)}
                helperText={touched.idNumber && errors.idNumber}
              />

              <TextField
                fullWidth
                autoComplete="username"
                type="email"
                label="Email address"
                {...getFieldProps('emailAddress')}
                error={Boolean(touched.emailAddress && errors.emailAddress)}
                helperText={touched.emailAddress && errors.emailAddress}
              />

              <TextField
                fullWidth
                autoComplete="cellNumber"
                type="string"
                label="Cell Number"
                {...getFieldProps('cellNumber')}
                error={Boolean(touched.cellNumber && errors.cellNumber)}
                helperText={touched.cellNumber && errors.cellNumber}
              />

              <TextField
                fullWidth
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                label="Password"
                {...getFieldProps('password')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                        <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
              />

              <TextField
                fullWidth
                autoComplete="confirm-password"
                type={showPassword ? 'text' : 'password'}
                label="Confirm Password"
                {...getFieldProps('confirmPassword')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                        <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                helperText={touched.confirmPassword && errors.confirmPassword}
              />

              {/* <FormControl>
                <InputLabel htmlFor="my-input">Email address</InputLabel>
                <Input id="my-input" aria-describedby="my-helper-text" />
                <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
              </FormControl> */}

              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                // loading={isSubmitting}
              >
                Register
              </LoadingButton>
            </Stack>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
